import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Scissors, ArrowLeft } from "lucide-react";

const CONTACT_EMAIL = "afanass34@gmail.com";
const CONTACT_PHONE = "+7 (988) 985-38-88";
// Реквизиты ИП — договор с платёжным оператором CloudPayments заключён на него
const OPERATOR = "Индивидуальный предприниматель Афанасьев Александр Вадимович, ИНН 340802226207, ОГРНИП 315344300000503";

const DOCS = {
  privacy: {
    title: "Политика конфиденциальности",
    marker: "Документ",
    updated: "Редакция от 20.10.2026",
    sections: [
      {
        h: "1. Общие положения",
        paras: [
          `Настоящая Политика конфиденциальности описывает, как ${OPERATOR} (далее — «Оператор») обрабатывает персональные данные пользователей сервиса «Дизайн Про» — сайта и мини-приложения Telegram @afanasievpro_bot (далее — «Сервис»).`,
          "Политика разработана в соответствии с Федеральным законом РФ от 27.07.2006 № 152-ФЗ «О персональных данных». Пользуясь Сервисом, вы принимаете условия настоящей Политики.",
        ],
      },
      {
        h: "2. Какие данные мы обрабатываем",
        paras: [
          "— Контактные данные: имя, номер телефона, адрес электронной почты — когда вы оставляете заявку или входите в личный кабинет.",
          "— Данные аккаунта Telegram: идентификатор пользователя (Telegram ID), имя и username — при входе через Telegram.",
          "— Сведения об использовании: количество доступных и использованных ИИ-примерок, выбранный тариф, история разборов и примерок в личном кабинете.",
          "— Фотографии. Подгонка маски и линий выполняется на вашем устройстве. Для ИИ-функций (разбор пропорций лица, примерка стрижки, подбор ухода за волосами) изображение передаётся автоматизированному сервису искусственного интеллекта для обработки по вашему запросу. Если вы вошли в личный кабинет, исходное фото и результаты (карточки примерок и ухода) сохраняются в истории вашего кабинета, чтобы вы могли к ним вернуться, — до удаления по вашему запросу (п. 7). У пользователей без кабинета результаты генераций хранятся обезличенно в технических целях.",
          "— Платежи: реквизиты банковской карты вводятся в защищённой платёжной форме оператора CloudPayments — нам они не передаются и не хранятся. Мы сохраняем только идентификатор платежа, сумму и статус.",
        ],
      },
      {
        h: "3. Цели обработки",
        paras: [
          "Предоставление доступа к Сервису и его платным функциям, учёт примерок и тарифов, исполнение договора (публичной оферты), обратная связь по вашим обращениям, улучшение качества Сервиса.",
        ],
      },
      {
        h: "4. Правовые основания",
        paras: [
          "Обработка выполняется на основании вашего согласия (ст. 6 ФЗ-152), которое вы даёте при отправке формы на сайте, а также в объёме, необходимом для исполнения договора с вами.",
        ],
      },
      {
        h: "5. Хранение и защита",
        paras: [
          "Данные хранятся на серверах Оператора и его технических подрядчиков. Мы применяем организационные и технические меры защиты: передачу по защищённому соединению, разграничение доступа, токенную авторизацию.",
          "Данные хранятся до достижения целей обработки или до отзыва вами согласия, если иное не требует закон.",
        ],
      },
      {
        h: "6. Передача третьим лицам",
        paras: [
          "Мы передаём данные только в объёме, необходимом для работы Сервиса: Telegram (платформа мини-приложения), платёжному оператору CloudPayments (приём оплаты; реквизиты карты видит только CloudPayments, не мы), провайдерам вычислительной инфраструктуры и сервисов искусственного интеллекта (обработка изображений по вашему запросу). Данные не продаются и не передаются третьим лицам в маркетинговых целях.",
        ],
      },
      {
        h: "7. Ваши права",
        paras: [
          "Вы можете запросить доступ к своим данным, их уточнение, блокирование или удаление (включая фотографии и историю разборов в личном кабинете), а также отозвать согласие на обработку. Для этого напишите на " + CONTACT_EMAIL + " — отвечаем в срок до 10 рабочих дней.",
        ],
      },
      {
        h: "8. Файлы cookies и локальное хранилище",
        paras: [
          "Сервис использует локальное хранилище браузера для сохранения токена входа, настроек и локальной сессии студии — загруженного фото и промежуточных результатов (хранится до 30 минут и удаляется автоматически; нужно, чтобы при случайном закрытии мини-приложения вы продолжили с того же места). Вы можете очистить хранилище в настройках браузера — тогда вход нужно будет выполнить заново.",
        ],
      },
      {
        h: "9. Изменение Политики",
        paras: [
          "Актуальная редакция Политики всегда доступна на этой странице. Продолжая пользоваться Сервисом после изменений, вы принимаете новую редакцию.",
        ],
      },
      {
        h: "10. Контакты Оператора",
        paras: [
          `Оператор: ${OPERATOR}`,
          `Электронная почта для обращений: ${CONTACT_EMAIL}`,
        ],
      },
    ],
  },
  offer: {
    title: "Публичная оферта",
    marker: "Договор",
    updated: "Редакция от 20.10.2026",
    sections: [
      {
        h: "1. Общие положения",
        paras: [
          `Настоящий документ является публичной офертой (ст. 437 ГК РФ) ${OPERATOR} (далее — «Исполнитель») о заключении договора на оказание услуг сервиса «Дизайн Про» (далее — «Сервис»).`,
          "Акцептом оферты является оплата выбранного тарифа. С момента оплаты договор считается заключённым на условиях ниже.",
        ],
      },
      {
        h: "2. Предмет договора",
        paras: [
          "Исполнитель предоставляет Пользователю доступ к платным функциям Сервиса: ИИ-примерки стрижек на фотографии, подбор ухода за волосами, сохранение результатов в истории кабинета, а в тарифах «Про» — технологические карты стрижек для мастеров. Доступ оформляется подпиской на срок (1 месяц, 6 месяцев или 1 год) либо пакетом примерок — пакет сроком не ограничен и действует до использования включённых генераций. Состав функций, срок действия и количество генераций определяются выбранным тарифом и публикуются на странице тарифов Сервиса.",
          "ИИ-разбор пропорций лица, маски и линии золотого сечения предоставляются безвозмездно.",
        ],
      },
      {
        h: "3. Стоимость и порядок оплаты",
        paras: [
          "Стоимость тарифов указана в рублях РФ на странице тарифов. Оплата производится банковской картой (Visa, Mastercard, «Мир») или через СБП в защищённой платёжной форме оператора CloudPayments. Реквизиты карты Исполнителю не передаются и не хранятся.",
          "Автоматического продления и повторных списаний нет: по окончании оплаченного срока доступ прекращается, продление выполняется отдельной покупкой по желанию Пользователя.",
          "Цена может изменяться Исполнителем в одностороннем порядке до момента оплаты; уже оплаченный доступ сохраняется на условиях покупки.",
        ],
      },
      {
        h: "4. Порядок оказания услуг",
        paras: [
          "Доступ открывается автоматически сразу после подтверждения оплаты — в личном кабинете Пользователя. Срок действия доступа соответствует тарифу (1 месяц, 6 месяцев или 1 год с момента активации).",
          "Количество ИИ-примерок ограничено тарифом и действует весь срок тарифа; неиспользованные примерки на следующий период не переносятся. При покупке нового тарифа до окончания текущего срок и генерации суммируются.",
          "Услуга считается оказанной с момента открытия доступа. Результаты работы искусственного интеллекта носят рекомендательный характер и могут отличаться от ожиданий Пользователя.",
        ],
      },
      {
        h: "5. Возврат средств",
        paras: [
          `Если платные функции не использовались, Пользователь вправе запросить полный возврат в течение 14 календарных дней с момента оплаты. Если функции использовались частично, возврат производится пропорционально неиспользованному объёму — в соответствии с Законом РФ «О защите прав потребителей».`,
          `Заявление на возврат направляется на ${CONTACT_EMAIL} с указанием аккаунта и даты оплаты. Срок рассмотрения — до 10 рабочих дней.`,
        ],
      },
      {
        h: "6. Ответственность сторон",
        paras: [
          "Сервис предоставляется «как есть». Исполнитель не отвечает за временную недоступность, вызванную работами у технических подрядчиков, и за решения, принятые Пользователем по результатам ИИ-анализа.",
          "Пользователь обязуется использовать Сервис в личных целях и не передавать доступ третьим лицам.",
        ],
      },
      {
        h: "7. Персональные данные",
        paras: [
          "Обработка персональных данных Пользователя выполняется в соответствии с Политикой конфиденциальности, размещённой на сайте Сервиса.",
        ],
      },
      {
        h: "8. Реквизиты Исполнителя",
        paras: [
          `Исполнитель: ${OPERATOR}`,
          "Адрес для корреспонденции: 400117, г. Волгоград, ул. Советская, д. 26а",
          `Телефон: ${CONTACT_PHONE}`,
          `Электронная почта: ${CONTACT_EMAIL}`,
        ],
      },
    ],
  },
  requisites: {
    title: "Реквизиты",
    marker: "Сведения",
    updated: "Редакция от 20.10.2026",
    sections: [
      {
        h: "Исполнитель",
        paras: [
          "Индивидуальный предприниматель Афанасьев Александр Вадимович.",
          "ИНН 340802226207 · ОГРНИП 315344300000503",
          "Адрес для корреспонденции: 400117, г. Волгоград, ул. Советская, д. 26а",
        ],
      },
      {
        h: "Контакты",
        paras: [
          `Телефон: ${CONTACT_PHONE}`,
          `Электронная почта: ${CONTACT_EMAIL}`,
          "Сервис «Дизайн Про»: сайт и мини-приложение Telegram @afanasievpro_bot.",
        ],
      },
      {
        h: "Услуги и оплата",
        paras: [
          "Сервис предоставляет доступ к ИИ-функциям: разбор пропорций лица, примерка стрижек на фотографии, подбор ухода за волосами, технологические карты для мастеров. Доступ оформляется подпиской (1 месяц, 6 месяцев, 1 год) или пакетом примерок.",
          "Оплата банковской картой (Visa, Mastercard, «Мир») или через СБП на защищённой странице платёжного сервиса. Цены опубликованы публично на главной странице сайта, раздел «Тарифы». Услуга цифровая — доставка не требуется: доступ к оплаченным функциям открывается автоматически сразу после оплаты в личном кабинете и мини-приложении Telegram. Условия — в Публичной оферте, обработка данных — в Политике конфиденциальности (ссылки выше).",
          "Сервис является собственной разработкой Исполнителя; товары и товарные знаки третьих лиц не реализуются.",
        ],
      },
      {
        h: "Возврат средств",
        paras: [
          `Возврат — по условиям раздела 5 Публичной оферты: полный в течение 14 дней, если платные функции не использовались. Заявления принимаются на ${CONTACT_EMAIL}.`,
        ],
      },
    ],
  },
  consent: {
    title: "Согласие на обработку персональных данных",
    marker: "Согласие",
    updated: "Редакция от 20.10.2026",
    sections: [
      {
        h: "Текст согласия",
        paras: [
          `Оставляя имя и номер телефона в форме на сайте «Дизайн Про», я свободно, своей волей и в своём интересе даю согласие ${OPERATOR} (далее — «Оператор») на обработку моих персональных данных.`,
          "Состав данных: имя, номер телефона, а при входе в личный кабинет — адрес электронной почты, идентификатор и username Telegram.",
          "Цели обработки: предоставление доступа к приложению, учёт подарочных и оплаченных примерок, оформление тарифов, обратная связь по моим обращениям.",
          "Разрешённые действия с данными: сбор, запись, систематизация, хранение, уточнение, использование, передача техническим подрядчикам в объёме, необходимом для работы сервиса, обезличивание, удаление.",
          `Согласие действует 5 (пять) лет с даты предоставления или до момента отзыва. Я вправе отозвать согласие, направив заявление на ${CONTACT_EMAIL}. Отзыв согласия не влияет на законность обработки до момента отзыва.`,
          "Мне известно, что фотографии для подгонки маски обрабатываются на моём устройстве; для ИИ-функций изображение передаётся автоматизированному сервису искусственного интеллекта для обработки по моему запросу, а при входе в личный кабинет исходное фото и результаты сохраняются в истории кабинета до моего запроса на удаление.",
          "С Политикой конфиденциальности и Публичной офертой ознакомлен(а) и согласен(на).",
        ],
      },
    ],
  },
};

const TITLES = { privacy: "Политика", offer: "Оферта", consent: "Согласие", requisites: "Реквизиты" };

export default function LegalPage({ doc = "privacy" }) {
  const d = DOCS[doc] || DOCS.privacy;
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F4F4F0]" data-testid={`legal-${doc}`}>
      <header className="fixed inset-x-0 top-0 z-40 border-b border-white/5 bg-[#0A0A0A]/80 backdrop-blur-xl">
        <div className="flex items-center justify-between px-6 py-4 md:px-12">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-logo">
            <Scissors size={15} strokeWidth={1.5} className="text-[#C2A878]" />
            <span className="font-jetbrains text-sm tracking-[0.35em] text-[#F4F4F0]">AFANASIEV</span>
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 font-jetbrains text-xs uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors duration-500 hover:text-[#C2A878]"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={12} strokeWidth={1.5} />
            На сайт
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-2xl px-6 pb-28 pt-28">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-jetbrains text-[10px] uppercase tracking-[0.35em] text-[#C2A878]">
            ( {d.marker} )
          </p>
          <h1 className="mt-5 font-cormorant text-4xl font-light leading-[1.05] tracking-tight text-[#F4F4F0] md:text-5xl">
            {d.title}
          </h1>
          <p className="mt-4 font-jetbrains text-[10px] uppercase tracking-[0.2em] text-[#525252]">{d.updated}</p>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 border-y border-white/5 py-4">
            {Object.keys(DOCS).map((k) => (
              <Link
                key={k}
                to={`/${k}`}
                className={`font-jetbrains text-[10px] uppercase tracking-[0.2em] transition-colors duration-300 ${
                  k === doc ? "text-[#C2A878]" : "text-[#525252] hover:text-[#F4F4F0]"
                }`}
                data-testid={`legal-nav-${k}`}
              >
                {TITLES[k]}
              </Link>
            ))}
          </div>

          <div className="mt-10 space-y-10">
            {d.sections.map((s, i) => (
              <section key={i}>
                <h2 className="font-cormorant text-2xl font-light text-[#C2A878]">{s.h}</h2>
                <div className="mt-4 space-y-3">
                  {s.paras.map((p, j) => (
                    <p key={j} className="text-sm leading-relaxed text-[#A3A3A3]">{p}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </motion.div>
      </main>
    </div>
  );
}
